












































import { Component, Vue } from 'vue-property-decorator';

import { StartGuideCardActiveProgram } from '@/models/start-guide';
import { IBusinessType } from '@/models/business';
import flagKeys from '@/constants/flagKeys';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import BoxProgramStatus from '@/componentsV2/molecules/BoxProgramStatus/BoxProgramStatus.vue';

import { isOnlineProvider } from '@/utils/provider';
import { showModalBillingLocationBenefits } from '@/utils/modal';
import { isExternalOauthSessionOnline } from '@/router/router-utils';
import eventBus from '@/utils/eventBus';
import BusinessService from '@/api/BusinessService';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    FilledButton,
    Typography,
    BoxProgramStatus
  }
})
export default class LoyaltyFeedbackStatus extends Vue {
  businessService = new BusinessService();

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get programStatus() {
    return { operationType: this.rewardOperationType };
  }

  get isRewardBoth() {
    return this.rewardOperationType === IBusinessType.BOTH;
  }

  get currentProvider() {
    return this.$store.getters['merchant/getCurrentProvider'];
  }

  get rewardOperationType() {
    if (
      this.businessInfo.operationType === IBusinessType.BOTH &&
      !this.flags.includes(flagKeys.addWixMultipleIntegration)
    ) {
      if (!this.currentProvider) return IBusinessType.INSTORE;

      return isOnlineProvider(this.currentProvider.name)
        ? IBusinessType.ONLINE
        : IBusinessType.INSTORE;
    }

    return this.businessInfo.operationType;
  }

  get submitText() {
    return 'Finish';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get activePrograms() {
    return this.$store.getters[
      'startGuide/getActivePrograms'
    ] as StartGuideCardActiveProgram[];
  }

  get rewardsProgramStatus() {
    const rewardCoinsProgram = this.activePrograms.find(
      program => program.slug === 'reward-coins'
    );

    if (
      !rewardCoinsProgram ||
      (this.$store.getters['business/getRewardStatus'] &&
        this.$store.getters['business/getRewardStatus'].rewardStatus ===
          'active')
    )
      return 'Active';

    return rewardCoinsProgram.label || 'Active';
  }

  async onFinish() {
    segmentIo.track('NPO Sign Up | Online Setup Flow Completed', {
      'Signup from Online Provider': true
    });
    this.$router.push({
      name: 'home',
      params: {
        resetBusinessOnboarding: 'true',
        showStartGuideHighlight: !isExternalOauthSessionOnline() ? 'true' : '',
        showBillingLocationBenefitsModal: showModalBillingLocationBenefits()
          ? 'true'
          : ''
      }
    });
  }

  async created() {
    if (!this.businessInfo) {
      this.businessService.getBusinessInfo().then((res: any) => {
        eventBus.$emit('setBusinessInfo', res.data);
        const data = res.data;
        data.manager = data.loggedInManager;
        this.$store.dispatch('business/SET_BUSINESS_INFO', {
          ...this.$store.getters['business/getBusinessState'],
          ...data
        });
      });
    }
  }
}
